import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-datewise-varganidar-rojmel-report',
  templateUrl: './datewise-varganidar-rojmel-report.component.html',
  styleUrls: ['./datewise-varganidar-rojmel-report.component.scss'],
})
export class DatewiseVarganidarRojmelReportComponent implements OnInit {
  startDate = '';
  endDate = '';
  rep_name;
  today = new Date();
  rojmelData;
  isLoading: boolean = false;
  subTypesName = [
    { name: 'वार्षिक', isVisible: false },
    { name: 'त्रैवार्षिक', isVisible: false },
    { name: 'पंचवार्षिक', isVisible: false },
    { name: 'रा.स्व.संघ ग्रंथ', isVisible: false },
    // { name: 'मुदत ठेव (पंचवार्षिक वर्गणीदार)', isVisible: false },
    // { name: 'रामसेवक ग्रंथयात्री', isVisible: false },
    // { name: 'लोकनेता गंथयात्री वार्षिक', isVisible: false },
    // { name: 'लोकमान्य ग्रंथयात्री वार्षिक वर्गणी', isVisible: false },
    // { name: 'हिंदुत्व ग्रंथयात्री', isVisible: false },
    // { name: 'हिंदुत्व 1', isVisible: false },
    // { name: 'हिंदुत्व 2', isVisible: false },
    // { name: 'आजीव', isVisible: false },
    // { name: 'अनामत', isVisible: false },
  ];
  totalth = 0;
  finalData = [];
  datewisedata: any;
  appliedFilters: any = {};   

  constructor(
    private service: DigisubservicesService,
    private dialogRef: MatDialogRef<DatewiseVarganidarRojmelReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    console.log(this.data, "thid data")
    this.isLoading = true;
    this.startDate = this.data['startDate'];
    this.endDate = this.data['endDate'];
    this.rep_name = this.data['rep_name'];
    // console.log(this.startDate, this.endDate);
    // console.log(this.data['data']);
    this.datewisedata = this.data['dataset'];

    console.log(this.datewisedata, "new data set")
    this.rojmelData = this.data['data'];
    // .filter((a) => {
    //   return (
    //     new Date(a['entry_date']) >= new Date(this.startDate) &&
    //     new Date(a['entry_date']) <= new Date(this.endDate)
    //   );
    // });
    // console.log(this.rojmelData);

     this.appliedFilters = this.data['appliedFilters'] || {};

     console.log("Applied Filters:", this.appliedFilters);

    let data = this.uniqueData(this.rojmelData, (a) => a.subscription_type);

    for (let i = 0; i < Object.keys(data).length; i++) {
      let flag = false;
      for (let j = 0; j < Object.keys(this.subTypesName).length; j++) {
        if (data[i]['subscription_type'] === this.subTypesName[j]['name']) {
          this.subTypesName[j]['isVisible'] = true;
          flag = true;
          break;
        }
      }
      if (!flag) {
        // if (
        //   data[i]['Subscription_Type'] !== 'हितचिंतक सप्रेम भेट' ||
        //   data[i]['Subscription_Type'] !== 'सप्रेम भेट - संपादकीय विभाग' ||
        //   data[i]['Subscription_Type'] !== 'जाहिरात स. भेट' ||
        //   data[i]['Subscription_Type'] !== 'संघ परिवार सप्रेम भेट' ||
        //   data[i]['Subscription_Type'] !== 'वर्गणी सप्रेम भेट'
        // ) {
        this.subTypesName.push({
          name: data[i]['subscription_type'],
          isVisible: true,
        });
        // }
      }
    }

    // console.log(this.subTypesName);
    // this.totalth = this.subTypesName.length * 3 + 9;
    this.totalth = this.subTypesName.filter(b => b.isVisible).length * 4 + 9;


    this.setData();
  }
  countryNameNew: any
  stateNameNew: any
  // setData() {
  //   // console.log(this.rojmelData);
  //   let uniqueDateData = this.uniqueData(this.rojmelData, (a) => a.entry_date);
  //   uniqueDateData.sort((a: any, b: any) => {
  //     return (
  //       new Date(a.entry_date).getTime() - new Date(b.entry_date).getTime()
  //     );
  //   });
  //   // console.log(
  //   // );
  //   let finalTotal = {};
  //   this.subTypesName.map((b: any, i) => {
  //     if (b.isVisible) {
  //       let name = this.getKey(b.name);
  //       finalTotal[name + '_एकूण'] = 0;
  //       finalTotal[name + '_नवीन'] = 0;
  //       finalTotal[name + '_नूतनीकरण'] = 0;
  //       if (i == 0) {
  //         finalTotal['name'] = 'एकूण';
  //         finalTotal['एकूण'] = 0;
  //         finalTotal['नवीन'] = 0;
  //         finalTotal['नूतनीकरण'] = 0;
  //       }
  //     }
  //   });

  //   for (let i = 0; i < uniqueDateData.length; i++) {
  //     let datewiseData = this.rojmelData.filter((a) => {
  //       return a.entry_date === uniqueDateData[i]['entry_date'];
  //     });
  //     // console.log(datewiseData);
  //     let totalData = {};
  //     this.subTypesName.map((b: any, i) => {
  //       if (b.isVisible) {
  //         let name = this.getKey(b.name);
  //         totalData[name + '_एकूण'] = 0;
  //         totalData[name + '_नवीन'] = 0;
  //         totalData[name + '_नूतनीकरण'] = 0;
  //         if (i == 0) {
  //           totalData['एकूण'] = 0;
  //           totalData['नवीन'] = 0;
  //           totalData['नूतनीकरण'] = 0;
  //         }
  //       }
  //     });
  //     datewiseData.map((a: any, i) => {
  //       if (i == 0)   totalData['entry_date'] = a.entry_date;
  //         let name = this.getKey(a.subscription_type);
  //         totalData[name + '_एकूण'] += parseInt(a.total_amt);
  //         finalTotal[name + '_एकूण'] += parseInt(a.total_amt);
  //         totalData[name + '_नवीन'] += a.rcpt_type == 'New' ? 1 : 0;
  //         finalTotal[name + '_नवीन'] += a.rcpt_type == 'New' ? 1 : 0;
  //         totalData[name + '_नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;
  //         finalTotal[name + '_नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;
  //         totalData['एकूण'] += parseInt(a.total_amt);
  //         finalTotal['एकूण'] += parseInt(a.total_amt);
  //         totalData['नवीन'] += a.rcpt_type == 'New' ? 1 : 0;
  //         finalTotal['नवीन'] += a.rcpt_type == 'New' ? 1 : 0;
  //         totalData['नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;
  //         finalTotal['नूतनीकरण'] += a.rcpt_type == 'Renew' ? 1 : 0;
          
        
         
  //     });
  //     datewiseData.push(totalData);
  //     this.countryNameNew = datewiseData[0].country
  //   this.stateNameNew = datewiseData[0].state
  //     this.finalData.push(datewiseData);
  //   }
    
  //   this.finalData.push(finalTotal);

  //   // let obj1 = this.finalData[0]
  //   // this.countryNameNew = obj1[0].country
  //   // this.stateNameNew = obj1[0].state
  //   console.log(this.finalData, "final data");

  //   this.isLoading = false;
  // }


// setData() {
//   this.finalData = [];
//   this.isLoading = true;

//   // Step 1: Get unique entry dates
//   const uniqueDateData = this.uniqueData(this.rojmelData, (a: any) => a?.crdt_voucher_date) as { crdt_voucher_date: string }[];

//   // Step 2: Sort dates ascending
//   uniqueDateData.sort((a, b) => {
//     const dateA = new Date(a.crdt_voucher_date).getTime();
//     const dateB = new Date(b.crdt_voucher_date).getTime();
//     return dateA - dateB;
//   });

//   // Step 3: Initialize final total
//   let finalTotal: any = {
//     name: 'एकूण',
//     एकूण: 0,
//     नवीन: 0,
//     नूतनीकरण: 0,
//   };

//   this.subTypesName.forEach((sub: any) => {
//     if (sub.isVisible) {
//       const key = this.getKey(sub.name);
//       finalTotal[key + '_एकूण'] = 0;
//       finalTotal[key + '_नवीन'] = 0;
//       finalTotal[key + '_नूतनीकरण'] = 0;
//     }
//   });

//   // Step 4: Process data date-wise
//   for (let i = 0; i < uniqueDateData.length; i++) {
//     const currentDate = uniqueDateData[i]?.crdt_voucher_date ?? '';
//     const datewiseData = this.rojmelData.filter((a: any) => a.crdt_voucher_date === currentDate);

//     // Step 4a: Initialize subtotal for this date
//     let subtotal: any = {
//       crdt_voucher_date: currentDate,
//       _isTotalRow: true,
//       एकूण: 0,
//       नवीन: 0,
//       नूतनीकरण: 0,
//     };

//     this.subTypesName.forEach((sub: any) => {
//       if (sub.isVisible) {
//         const key = this.getKey(sub.name);
//         subtotal[key + '_एकूण'] = 0;
//         subtotal[key + '_नवीन'] = 0;
//         subtotal[key + '_नूतनीकरण'] = 0;
//       }
//     });

//     for (let record of datewiseData) {
//       const key = this.getKey(record.subscription_type);
//       const amt = parseInt(record.total_amt, 10) || 0;

//       // Step 4b: Add individual record with subtype-wise fields
//       let row: any = { ...record, _isIndividual: true };
//       this.subTypesName.forEach((sub: any) => {
//         if (sub.isVisible) {
//           const subKey = this.getKey(sub.name);
//           row[subKey + '_एकूण'] = subKey === key ? amt : 0;
//           row[subKey + '_नवीन'] = (subKey === key && record.rcpt_type === 'New') ? 1 : 0;
//           row[subKey + '_नूतनीकरण'] = (subKey === key && record.rcpt_type === 'Renew') ? 1 : 0;
//         }
//       });

//       this.finalData.push(row); // Step 4c: Add to final data

//       // Step 4d: Update subtotal
//       subtotal[key + '_एकूण'] += amt;
//       subtotal['एकूण'] += amt;

//       if (record.rcpt_type === 'New') {
//         subtotal[key + '_नवीन'] += 1;
//         subtotal['नवीन'] += 1;
//       } else if (record.rcpt_type === 'Renew') {
//         subtotal[key + '_नूतनीकरण'] += 1;
//         subtotal['नूतनीकरण'] += 1;
//       }

//       // Step 4e: Update final total
//       finalTotal[key + '_एकूण'] += amt;
//       finalTotal['एकूण'] += amt;

//       if (record.rcpt_type === 'New') {
//         finalTotal[key + '_नवीन'] += 1;
//         finalTotal['नवीन'] += 1;
//       } else if (record.rcpt_type === 'Renew') {
//         finalTotal[key + '_नूतनीकरण'] += 1;
//         finalTotal['नूतनीकरण'] += 1;
//       }
//     }

//     // Step 4f: Get location data
//     if (datewiseData.length > 0) {
//       this.countryNameNew = datewiseData[0].country;
//       this.stateNameNew = datewiseData[0].state;
//     }

//     // Step 4g: Push subtotal for the date
//     this.finalData.push(subtotal);
//   }

//   // Step 5: Push grand total at the end
//   this.finalData.push(finalTotal);

//   console.log(this.finalData, 'final data');
//   this.isLoading = false;
// }

setData() {
  this.finalData = [];
  this.isLoading = true;

  // Step 1: Get unique entry dates
  const uniqueDateData = this.uniqueData(this.rojmelData, (a: any) => a?.crdt_voucher_date) as { crdt_voucher_date: string }[];

  // Step 2: Sort dates ascending
  uniqueDateData.sort((a, b) => {
    const dateA = new Date(a.crdt_voucher_date).getTime();
    const dateB = new Date(b.crdt_voucher_date).getTime();
    return dateA - dateB;
  });

  // Step 3: Initialize final total
  let finalTotal: any = {
    name: 'एकूण',
    एकूण: 0,
    नवीन: 0,
    नूतनीकरण: 0,
  };

  this.subTypesName.forEach((sub: any) => {
    if (sub.isVisible) {
      const key = this.getKey((sub.name || '').trim());
      finalTotal[key + '_एकूण'] = 0;
      finalTotal[key + '_नवीन'] = 0;
      finalTotal[key + '_नूतनीकरण'] = 0;
    }
  });

  // Step 4: Process data date-wise
  for (let i = 0; i < uniqueDateData.length; i++) {
    const currentDate = uniqueDateData[i]?.crdt_voucher_date ?? '';
    const datewiseData = this.rojmelData.filter((a: any) => a.crdt_voucher_date === currentDate);

    // Step 4a: Initialize subtotal for this date
    let subtotal: any = {
      crdt_voucher_date: currentDate,
      _isTotalRow: true,
      एकूण: 0,
      नवीन: 0,
      नूतनीकरण: 0,
    };

    this.subTypesName.forEach((sub: any) => {
      if (sub.isVisible) {
        const key = this.getKey((sub.name || '').trim());
        subtotal[key + '_एकूण'] = 0;
        subtotal[key + '_नवीन'] = 0;
        subtotal[key + '_नूतनीकरण'] = 0;
      }
    });

    for (let record of datewiseData) {
      const rawType = (record.subscription_type || '').trim();
      const key = this.getKey(rawType);
      const amt = parseInt(record.total_amt, 10) || 0;
      const rcptType = record.rcpt_type;

      // Step 4b: Add individual record with subtype-wise fields
      let row: any = { ...record, _isIndividual: true };
      this.subTypesName.forEach((sub: any) => {
        if (sub.isVisible) {
          const subKey = this.getKey((sub.name || '').trim());
          row[subKey + '_एकूण'] = subKey === key ? amt : 0;
          row[subKey + '_नवीन'] = subKey === key && rcptType === 'New' ? 1 : 0;
          row[subKey + '_नूतनीकरण'] = subKey === key && rcptType === 'Renew' ? 1 : 0;
        }
      });

      this.finalData.push(row); // Step 4c: Add to final data

      // Step 4d: Update subtotal
      this.subTypesName.forEach((sub: any) => {
        if (sub.isVisible) {
          const subKey = this.getKey((sub.name || '').trim());
          if (subKey === key) {
            subtotal[subKey + '_एकूण'] += amt;
            subtotal['एकूण'] += amt;

            if (rcptType === 'New') {
              subtotal[subKey + '_नवीन'] += 1;
              subtotal['नवीन'] += 1;
            } else if (rcptType === 'Renew') {
              subtotal[subKey + '_नूतनीकरण'] += 1;
              subtotal['नूतनीकरण'] += 1;
            }
          }
        }
      });

      // Step 4e: Update final total
      this.subTypesName.forEach((sub: any) => {
        if (sub.isVisible) {
          const subKey = this.getKey((sub.name || '').trim());
          if (subKey === key) {
            finalTotal[subKey + '_एकूण'] += amt;
            finalTotal['एकूण'] += amt;

            if (rcptType === 'New') {
              finalTotal[subKey + '_नवीन'] += 1;
              finalTotal['नवीन'] += 1;
            } else if (rcptType === 'Renew') {
              finalTotal[subKey + '_नूतनीकरण'] += 1;
              finalTotal['नूतनीकरण'] += 1;
            }
          }
        }
      });
    }

    // Step 4f: Set location (optional)
    if (datewiseData.length > 0) {
      this.countryNameNew = datewiseData[0].country;
      this.stateNameNew = datewiseData[0].state;
    }

    // Step 4g: Push subtotal for the date
    this.finalData.push(subtotal);
  }

  // Step 5: Push grand total at the end
  this.finalData.push(finalTotal);

  console.log(this.finalData, 'final data');
  this.isLoading = false;
}




getKey(name: string): string {
  return name?.trim().replace(/\s+/g, '_');  // e.g., "राष्ट्रोत्थान 2100" → "राष्ट्रोत्थान_2100"
}


  // getKey(name) {
  //   return name.replaceAll(' ', '_');
  // }

  uniqueData(data, key) {
    return [...new Map(data.map((a) => [key(a), a])).values()];
  }

  exportExcel(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }


   //Main Report Method Use in all Printing Page
  show = false
  printPage() {
    this.show = true
    const printContent = document.getElementById('print-section')?.outerHTML;
    if (!printContent) {
      console.error("Print section not found!");
      return;
    }

    const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
             <html>
                 <head>
                     <title>Print Report</title>
                     <style>
                         @media print {
                             @page { 
                                 size: A3 landscape; /* Set A3 size with landscape mode */
                                 margin: 5mm; /* Adjust margins */
                             }
                             body { 
                                 font-family: Arial, sans-serif; 
                                 font-size: 15px; /* Adjust font size */
                                 margin: 0; 
                                 padding: 5mm; 
                                 line-height: 1.2; 
                             }
                             table { 
                                 width: 100%; 
                                
                                 border-collapse: collapse; 
                                 table-layout: fixed; /* Prevent column expansion */
                                 page-break-inside: avoid; /* Avoid breaking the table */
                                    table-layout: auto !important; 
                             }
                             th { 
                                 padding: 1px; 
                                 border: 1px solid black; 
                                 text-align: center; 
                                 font-size: 12px; /* Adjusted font size */
                                 line-height: 1.2; 
                                 white-space: normal;         /* Allow wrapping */
                                 word-wrap: break-word;
                             }

                             td {
                                 padding: 1px;
                                 border: 1px solid black;
                                 text-align: left; /* Left align data */
                                 font-size: 12px;
                                 line-height: 1.2;
                                }
                             .noPrint { 
                                 display: none; /* Hide print button */
                             }
                         }
                     </style>
                 </head>
                 <body>
                     <div id="print-section">
                         ${printContent}
                     </div>
                     <script>
                         window.onload = function() { 
                             window.print(); 
                             setTimeout(() => { window.close(); }, 500);
                         };
                     </script>
                 </body>
             </html>
         `);
      printWindow.document.close();
    } else {
      console.error("Failed to open print window.");
    }
  }

}
